<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"></a><div class="title-frontMatter"><strong class="b">“You Don’t Have To Pay Me Back,”</strong></div>
<div class="p"><span>Boone insisted.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>That voice. So low and husky. So slow and sexy. Every time Boone said something, it sent a ripple of delight buzzing through Lucy’s libido.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>She ignored him and said, “Here’s what I’m going to do—”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>“Lucy...like I keep telling you, it’s not necessary to pay me back for anything. Okay?”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Lucy hurried on. “Here’s the deal. I’m giving you myself for one month.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>When he seemed not to understand, Lucy tried again. “I’m yours to do your bidding, at your beck and call, for four weeks.”</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>He still seemed mystified.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Finally, in an effort to make it as clear as possible, Lucy told him, “For the next thirty days, Boone Cagney, I’ll do whatever you tell me to do. Because for the next thirty days, I’m going to be your slave.”</span></div>
<div class="illustype_image"><div class="image"><img alt="9781459271517_i0001.jpg" src="9781459271517_i0001.jpg"/></div></div>
<div class="p-c"><span>THE FAMILY McCORMICK: Three separated siblings find each other—and love along the way!</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459271517_fm01.vue?719d82de